import { exists } from '@/api'

export interface BatchCollectionMgmtBibliographyBulkRemovalConditionListItem {
  registDateFrom: string
  registDateTo: string
  marcType: string
  marcNoFrom: string
  marcNoTo: string
  materialFormat: string
  rdoSearchType: string
  rdoRemovalTarget: string
  rdoDatabaseUpdate: string
  memo: string
  batchType: string
}

export function BatchCollectionMgmtBibliographyBulkRemovalConditionListItemFromJSON(
  json: any
): BatchCollectionMgmtBibliographyBulkRemovalConditionListItem {
  const resp = JSON.parse(json)

  return {
    registDateFrom: exists(resp, 'regist_date_from')
      ? resp.regist_date_from
      : '',
    registDateTo: exists(resp, 'regist_date_to') ? resp.regist_date_to : '',
    marcType: exists(resp, 'marc_type') ? resp.marc_type : '',
    marcNoFrom: exists(resp, 'marc_no_from') ? resp.marc_no_from : '',
    marcNoTo: exists(resp, 'marc_no_to') ? resp.marc_no_to : '',
    materialFormat: exists(resp, 'material_format') ? resp.material_format : '',
    rdoSearchType: exists(resp, 'rdo_search_type') ? resp.rdo_search_type : '1',
    rdoRemovalTarget: exists(resp, 'rdo_removal_target')
      ? resp.rdo_removal_target
      : '1',
    rdoDatabaseUpdate: exists(resp, 'rdo_database_update')
      ? resp.rdo_database_update
      : '2',
    memo: exists(resp, 'memo') ? resp.memo : '',
    batchType: resp.batch_type
  }
}
